import type { Slicers } from 'types/services';
import { SLICER_KEYS } from 'types/services';

export const selectAllNavigationStates = (state: Slicers) => state[SLICER_KEYS.NAVIGATION_STATE];

export const selectNavigationState =
  <TData extends Record<string, unknown>>(key: string) =>
  (state: Slicers): TData | undefined => {
    const states = state[SLICER_KEYS.NAVIGATION_STATE];
    if (!states || !states[key]) return undefined;
    return states[key].data as TData;
  };
